import { useNavigation } from "@react-navigation/core";
import React, { useEffect, useState } from "react";
import { ScrollView, View } from "react-native";
import AsyncStorage from "@react-native-async-storage/async-storage";
import GoBackButton from "../../components/GoBackButton";
import HeaderTabs from "../../components/HeaderTabs";
import { styles } from "./styles";
import { FormattedMessage } from "react-intl";
import ButtonsActionTransaction from "../../components/ButtonsActionTransaction";

const WithdrawMethod = () => {
  const navigation = useNavigation();
  const [clientCountry, setClientCountry] = useState("");

  const getClientCountry = async () => {
    const country = await AsyncStorage.getItem("client_country");
    setClientCountry(country);
  };

  useEffect(() => {
    getClientCountry();
  }, []);

  const buttons =
    clientCountry === "brasil"
      ? [
          {
            text: <FormattedMessage id="withdrawmethod.sacarGpx" />,
            route: "WithdrawGPXAccountSelection",
          },
          {
            text: <FormattedMessage id="withdrawmethod.sacarBtc" />,
            route: "WithdrawCryptoSelection",
          },
          {
            text: <FormattedMessage id="withdrawmethod.sacarPaperWallet" />,
            route: "PaperWallet",
          },
        ]
      : [
          {
            text: <FormattedMessage id="withdrawmethod.sacarPaperWallet" />,
            route: "PaperWallet",
          },
        ];

  return (
    <View>
      <HeaderTabs
        title={<FormattedMessage id="withdrawmethod.sacar" />}
        subtitle={<FormattedMessage id="marketplacecategories.subtitulo" />}
      />

      <ScrollView>
        <ButtonsActionTransaction buttons={buttons} navigation={navigation} />

        <GoBackButton />
      </ScrollView>
    </View>
  );
};

export default WithdrawMethod;
